import { Component, OnInit } from '@angular/core';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }


  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;


  onPageChange(newValue) {
   // console.log('value',newValue.target.innerHTML);
    
    this.selectedPage = newValue.target.innerHTML;
    this.perpageitem = newValue.target.innerHTML;
  }

}
